var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
function HomePlus(_a) {
    var width = _a.width, height = _a.height, props = __rest(_a, ["width", "height"]);
    var size = width || height || 20;
    return (React.createElement(Icon, __assign({ "data-icon": 'home-plus', viewBox: "0 0 20 20", width: size, height: size }, props),
        React.createElement("g", { fill: "currentColor", fillOpacity: props.fillOpacity || 0, stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", transform: "translate(2.5, 1.7)" },
            React.createElement("path", { d: "M0,5.83333333 L7.5,-1.95399252e-14 L15,5.83333333 L15,15 C15,15.9204746 14.2538079,16.6666667 13.3333333,16.6666667 L1.66666667,16.6666667 C0.746192084,16.6666667 0,15.9204746 0,15 L0,5.83333333 Z", id: "Path" }),
            React.createElement("g", { transform: "translate(4.000000, 6.833333)" },
                React.createElement("line", { x1: "3.5", y1: "1.07414078e-14", x2: "3.5", y2: "6", id: "Line-5" }),
                React.createElement("line", { x1: "3.5", y1: "1.07414078e-14", x2: "3.5", y2: "6", id: "Line-5-Copy", transform: "translate(3.500000, 3.000000) rotate(-90.000000) translate(-3.500000, -3.000000) " })))));
}
export default styled(HomePlus)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
